module.exports = __webpack_public_path__ + "static/media/ashen-cloud.8dedca58.png";